
import initWeb3 from "./initWeb3";
import { ethers } from "ethers";
import {
    SBNAddress,
} from '@/abi/address';
import { useSelector } from "react-redux";
const useAllowance = () => {
    const { address } = useSelector(state => state.home)
    const allowanceHandler = async () => {
        
        const allowance = await window.token.allowance(address, SBNAddress);
        console.log("当前授权额度:", ethers.formatUnits(allowance, 18));
        if (allowance <= 0) {
            try {
              
                const bal = await window.contract.methods.balanceOf(address).call()
                // const balance = parseInt(bal/1000000000000000000)
                console.log('bal:', bal)

                // 3. 调用 approve 授权
                const amount = ethers.parseUnits(bal, 18); // 授权 1000 个代币（注意小数位数）
                const tx = await window.token.approve(SBNAddress, amount);
                console.log("授权交易发送中，TxHash:", tx.hash);
                
            } catch (error) {
                    console.log('error:',error)
            }
        }
    }
    return initWeb3(allowanceHandler)
}
export default useAllowance